import { render } from "./UseResourceBonusResConfirm.vue?vue&type=template&id=942d053a"
import script from "./UseResourceBonusResConfirm.vue?vue&type=script&lang=js"
export * from "./UseResourceBonusResConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/windowOverlay/UseResourceBonusResConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "942d053a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('942d053a', __exports__)) {
    api.reload('942d053a', __exports__)
  }
  
  module.hot.accept("./UseResourceBonusResConfirm.vue?vue&type=template&id=942d053a", () => {
    api.rerender('942d053a', render)
  })

}


export default __exports__